import React from 'react';
import { Link } from 'gatsby';

const SecondaryNav = ({ footer }) => {
    return (
        <div id="secondary-nav-target">
            <nav>
                <ul className="nav-list">
                    {footer.map((link, key) => (
                        <li
                            className={`menu--${key}`}
                            key={`main-menu--${key}`}
                        >
                            <Link to={link.uri} activeClassName="active">
                                {link.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default SecondaryNav;
